<div class="external-redirect">
  <div *ngIf="isLoading" class="text-center d-flex align-items-center flex-column justify-content-center">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    <div class="mt-5">Aguarde... estamos te redirecionando.</div>
  </div>

  <div *ngIf="!isLoading" class="text-center d-flex align-items-center flex-column justify-content-center">
    <div>Ocorreu algum erro durante o redirecionamento.</div>
  </div>
</div>